import { downloadFiles } from '@/utils/client/fileHelper';
import { Dropdown } from 'antd';
import axios from 'axios';
import { useContext } from 'react';
import { LibraryContext } from './context-provider';

export default function FileContextMenu({ trigger, permission, children }) {
   const { selectedLibrary, setDeleteModalOpen, setRenameModalOpen, setMoveModalOpen, setShareModalOpen } =
      useContext(LibraryContext);

   async function handleDownload() {
      // get signed urls for all files
      const urls = await axios.get('/api/library/download', {
         params: {
            files: selectedLibrary.map((item) => item._id).join(','),
         },
      });
      // download files using signed urls
      downloadFiles(urls.data.urls);
   }

   const menu = [
      {
         key: 'download',
         label: 'Download',
         icon: <i className="fi fi-rr-download" />,
         onClick: () => handleDownload(),
      },
      {
         key: 'move',
         label: 'Move to',
         icon: <i className="fi fi-rr-move-to-folder" />,
         disabled: !permission || permission === 'read',
         onClick: () => setMoveModalOpen(true),
      },
      {
         key: 'rename',
         label: 'Rename',
         icon: <i className="fi fi-rr-edit-alt" />,
         disabled: !permission || permission === 'read',
         onClick: () => setRenameModalOpen(true),
      },
      {
         key: 'share',
         label: 'Share',
         icon: <i className="fi fi-rr-share" />,
         disabled: !permission || permission === 'read',
         onClick: () => setShareModalOpen(true),
      },
      {
         key: 'delete',
         label: 'Delete',
         icon: <i className="fi fi-rr-trash" />,
         disabled: !permission || permission === 'read',
         onClick: () => setDeleteModalOpen(true),
      },
   ];

   return (
      <>
         <Dropdown trigger={trigger} menu={{ items: menu }}>
            {children}
         </Dropdown>
      </>
   );
}
